<template>
  <div class="text-center">
    <div>
      <iconpark-icon name="pay-succ" class="text-[56px]"></iconpark-icon>
    </div>
    <div class="mt-[16px] font-medium text-font-1 text-[20px] leading-[28px]">
      {{ $t('tuan-dui-ti-yan-ban-chuang-jian-cheng-gong') }}
    </div>
    <div class="mt-[10px] text-font-40">
      <span>{{ $t('nin-yi-zhu-ce-cheng-gong') }} &nbsp;</span>
      <template
        v-if="
          userInfo?.account_activity_total_credit_coin &&
          userInfo?.apply_credit_coin_expired_time
        "
      >
        <span>{{ $t('xin-yong-hu-zhu-ce-yi-wei-nin-zi-dong-fa-fang') }}</span>
        <span class="text-primary">
          &nbsp;{{ userInfo.account_activity_total_credit_coin }}
          {{ $t('yan-bi') }}
        </span>
        <span>
          （
          {{ $t('you-xiao-qi-zhi') }}
          {{
            timeFormat(
              userInfo.apply_credit_coin_expired_time + '',
              'YYYY-MM-DD'
            )
          }}
          ），
        </span>
      </template>
      <span>
        {{ $t('kuai-su-kai-shi-nin-de-3d-shi-pin-chuang-zuo-zhi-lv-ba') }}
      </span>
    </div>
    <Intro :list="data" class="text-left mx-auto">
      <div class="mt-[30px]">
        <a-button
          v-if="!isGlobalVersion()"
          type="primary"
          ghost
          class="mr-[20px]"
          @click="goLink(PageKey.ACCOUNT_VERIFY)"
        >
          <a-popover :title="$t('ren-zheng-quan-yi-dui-bi')" placement="left">
            <template #content>
              <CertificationCompare />
            </template>
            <iconpark-icon
              name="info"
              class="mr-[8px] align-middle"
            ></iconpark-icon>
          </a-popover>
          <span v-if="isChinese()" class="align-middle">
            {{ $t('qu-ren-zheng') }}
          </span>
        </a-button>
        <a-button type="primary" @click="goLink('home')">
          {{ $t('kai-shi-you-yan') }}
        </a-button>
      </div>
      <XAttract :source="AttractSource.TASTE_REGISTER" type="fixed" />
    </Intro>
  </div>
</template>
<script lang="ts" setup>
import Intro from '~/features/intro/index.vue'
import { CertificationCompare } from '~/features/certificationCompare'
import XAttract from '~/components/xAttract/index.vue'
import { AttractSource } from '~/components/xAttract/constant'
import { useTime } from '~/hooks/useTime'
import { PageKey } from '~/constants/page'
// defineProps<{
//   // 这里暂时先这么写，防止逻辑有变更，后面改成通过  获取
//   userInfo: UserInfo
// }>()

const userInfo = useUserInfo()

const { timeFormat } = useTime()

type CardInfo = {
  url: string
  name: string
  desc: string
}

const { $t } = useNuxtApp()

const data: CardInfo[] = [
  {
    url: getFeUrl('/youyan-platform/png/team_admin.png'),
    name: $t('tuan-dui-guan-li'),
    desc: $t('yao-qing-cheng-yuan-jia-ru-fen-xiang-zuo-pin-xie-zuo'),
  },
  {
    url: getFeUrl('/youyan-platform/png/team_space.png'),
    name: $t('tuan-dui-kong-jian'),
    desc: $t('tuan-dui-gong-xiang-kong-jian-quan-yuan-nei-rong-ke-jian'),
  },
  {
    url: getFeUrl('/youyan-platform/png/team_specification.png'),
    name: $t('pin-pai-gui-fan'),
    desc: $t('wei-hu-pin-pai-gui-fan-tong-yi-qi-ye-xing-xiang'),
  },
]

const router = useRouter()

const goLink = (name: string) => {
  router.push({
    name,
  })
}

onMounted(() => {
  trackEvent(TRACK_EVENT.TEAM_REGISTER_SUCCESS)
})
</script>
<style lang="scss" scoped>
.card {
  @apply px-[16px] py-[30px] bg-back-1;
  transition: all 3s ease-in-out;
  &:hover {
    background: linear-gradient(
      to right bottom,
      #e1fff9 0%,
      #f5feff 33%,
      #ffffff 66%,
      #d8d5ff 100%
    );
  }
}
</style>
